<template>
  <NuxtLink
    :to="href"
    class="group flex h-[350px] w-full max-w-[510px] flex-col overflow-hidden rounded-[20px] border border-gray-border bg-white-gray"
  >
    <div
      class="flex min-w-0 items-start justify-between pl-[30px] pr-[20px] pt-[30px]"
    >
      <p
        class="min-w-0 pr-4 text-fluid-display text-ellipsis-2 font-helvetica-700 font-bold"
      >
        <slot />
      </p>

      <SvgoIconComponentGIconArrow class="shrink-0 -rotate-45 transition-transform duration-300 group-hover:rotate-0"></SvgoIconComponentGIconArrow>
    </div>

    <div
      class="flex flex-1 min-h-0 items-center justify-center overflow-hidden px-2 pb-2 pt-1"
    >
      <img
        :src="src"
        alt=""
        class="block max-h-full max-w-full object-contain object-center [clip-path:inset(3px_0_0_0)]"
        :class="imageClass"
      />
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
defineProps<{
  href: string
  src: string
  imageClass?: string
}>()
</script>